import type { ParsedLocation } from '@tanstack/react-router'

interface ScrollRestorationInput {
  location: ParsedLocation
}

// The router counts every query string rewrite as a navigation, and the app rewrites it on
// each keystroke in a search box (page number, filters). Only a new path is a new page,
// so only then may the router reset or restore the scroll.
export const createScrollOnNewPageOnly = () => {
  let lastPathname: string | undefined

  return ({ location }: ScrollRestorationInput): boolean => {
    const isNewPage = location.pathname !== lastPathname
    lastPathname = location.pathname
    return isNewPage
  }
}
